import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import Splash from './Pages/Splash';
import VirtualAccountGuide from './Pages/VirtualAccountGuide';
import VirtualAccountIssue from './Pages/VirtualAccountIssue';

function App() {
    return (
        <div className="App">
            <div className="App-section">
                <div className="App-sction-box">
                    <Routes>
                        <Route path="/" element={<Splash />} />
                        <Route path="/guide" element={<VirtualAccountGuide />} />
                        <Route path="/issue" element={<VirtualAccountIssue />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}

export default App;